import React from 'react';

const About = ({ currentLanguage = 'KM' }) => {
  const getFontClass = () => {
    return currentLanguage === 'KM' ? 'font-khmer' : 'font-inter';
  };

  const content = {
    EN: {
      title: "About Us",
      subtitle: "Your Trusted Beauty & Wellness Partner",
      description: "Welcome to THE KING BEAUTY, where beauty meets expertise. We are dedicated to providing exceptional beauty and wellness services in a comfortable and professional environment.",
      mission: {
        title: "Our Mission",
        text: "To help every client look and feel their absolute best through personalized beauty services and expert care."
      },
      story: {
        title: "Our Story",
        text: "Founded with a passion for beauty and wellness, THE KING BEAUTY has been serving our community with premium services and professional care. Our team of experienced stylists and therapists are committed to delivering outstanding results."
      },
      values: {
        title: "Why Choose Us",
        items: [
          {
            icon: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "Expert Team",
            description: "Highly trained and certified professionals"
          },
          {
            icon: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z",
            title: "Quality Products",
            description: "Premium brands and top-quality products"
          },
          {
            icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "Flexible Hours",
            description: "Convenient scheduling to fit your lifestyle"
          },
          {
            icon: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "Customer First",
            description: "Your satisfaction is our top priority"
          }
        ]
      },
      stats: [
        { number: "5+", label: "Years Experience" },
        { number: "1000+", label: "Happy Clients" },
        { number: "10+", label: "Expert Staff" },
        { number: "15+", label: "Services Offered" }
      ],
      contact: {
        phone: "077221295",
        telegram: "@chhanryda",
        telegramLink: "https://t.me/chhanryda"
      }
    },
    KM: {
      title: "អំពីយើង",
      subtitle: "ដៃគូសម្រស់ និងសុខភាពដែលអ្នកទុកចិត្ត",
      description: "សូមស្វាគមន៍មកកាន់ THE KING BEAUTY ជាកន្លែងដែលសម្រស់ជួបជាមួយនឹងជំនាញ។ យើងឧទ្ទិសខ្លួនដើម្បីផ្តល់សេវាកម្មសម្រស់ និងសុខភាពដ៏ពិសេសនៅក្នុងបរិយាកាសដ៏ងាយស្រួល និងមានវិជ្ជាជីវៈ។",
      mission: {
        title: "បេសកកម្មរបស់យើង",
        text: "ជួយអតិថិជនគ្រប់រូបឱ្យមើលទៅ និងមានអារម្មណ៍ល្អបំផុតតាមរយៈសេវាកម្មសម្រស់ប្តូរតាមបុគ្គល និងការថែទាំដោយអ្នកជំនាញ។"
      },
      story: {
        title: "រឿងរ៉ាវរបស់យើង",
        text: "បានបង្កើតឡើងដោយចំណង់ចំណូលចិត្តលើសម្រស់ និងសុខភាព THE KING BEAUTY បានបម្រើសហគមន៍របស់យើងជាមួយនឹងសេវាកម្មដ៏ពិសេស និងការថែទាំដោយវិជ្ជាជីវៈ។ ក្រុមអ្នកជំនាញធ្វើសក់ និងអ្នកព្យាបាលដែលមានបទពិសោធន៍របស់យើងប្តេជ្ញាចិត្តផ្តល់លទ្ធផលដ៏អស្ចារ្យ។"
      },
      values: {
        title: "ហេតុអ្វីជ្រើសរើសយើង",
        items: [
          {
            icon: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "ក្រុមអ្នកជំនាញ",
            description: "អ្នកជំនាញដែលបានបណ្តុះបណ្តាល និងមានវិញ្ញាបនបត្រ"
          },
          {
            icon: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z",
            title: "ផលិតផលគុណភាព",
            description: "ម៉ាកល្បីល្បាញ និងផលិតផលគុណភាពខ្ពស់"
          },
          {
            icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "ម៉ោងបត់បែន",
            description: "កាលវិភាគងាយស្រួលសម្រាប់របៀបរស់នៅរបស់អ្នក"
          },
          {
            icon: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "អតិថិជនជាមុន",
            description: "ការពេញចិត្តរបស់អ្នកគឺជាអាទិភាពកំពូលរបស់យើង"
          }
        ]
      },
      stats: [
        { number: "៥+", label: "ឆ្នាំបទពិសោធន៍" },
        { number: "១០០០+", label: "អតិថិជនពេញចិត្ត" },
        { number: "១០+", label: "បុគ្គលិកជំនាញ" },
        { number: "១៥+", label: "សេវាកម្មផ្តល់" }
      ],
      contact: {
        phone: "077221295",
        telegram: "@chhanryda",
        telegramLink: "https://t.me/chhanryda"
      }
    }
  };

  const currentContent = content[currentLanguage] || content.KM;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Battambang:wght@300;400;500;600;700&display=swap');
        
        .font-khmer {
          font-family: 'Battambang', 'Khmer OS', 'Noto Sans Khmer', sans-serif;
        }

        .font-inter {
          font-family: 'Inter', 'Battambang', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }
      `}</style>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className={`text-3xl md:text-4xl font-bold text-gray-900 mb-3 ${getFontClass()}`}>
              {currentContent.title}
            </h2>
            <p className={`text-xl text-[#f2c742] font-semibold mb-4 ${getFontClass()}`}>
              {currentContent.subtitle}
            </p>
            <p className={`text-lg text-gray-600 max-w-3xl mx-auto ${getFontClass()}`}>
              {currentContent.description}
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
            {currentContent.stats.map((stat, index) => (
              <div key={index} className="text-center p-6 bg-gray-50 rounded-lg">
                <div className={`text-3xl md:text-4xl font-bold text-[#f2c742] mb-2 ${getFontClass()}`}>
                  {stat.number}
                </div>
                <div className={`text-sm md:text-base text-gray-600 ${getFontClass()}`}>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          {/* Mission & Story */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {/* Mission */}
            <div className="bg-[#f2c742] bg-opacity-10 p-8 rounded-lg border border-[#f2c742] border-opacity-20">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-[#f2c742] rounded-lg flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className={`text-2xl font-bold text-gray-900 ${getFontClass()}`}>
                  {currentContent.mission.title}
                </h3>
              </div>
              <p className={`text-gray-700 leading-relaxed ${getFontClass()}`}>
                {currentContent.mission.text}
              </p>
            </div>

            {/* Story */}
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gray-700 rounded-lg flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
                <h3 className={`text-2xl font-bold text-gray-900 ${getFontClass()}`}>
                  {currentContent.story.title}
                </h3>
              </div>
              <p className={`text-gray-700 leading-relaxed ${getFontClass()}`}>
                {currentContent.story.text}
              </p>
            </div>
          </div>

          {/* Why Choose Us */}
          <div>
            <h3 className={`text-2xl md:text-3xl font-bold text-gray-900 text-center mb-10 ${getFontClass()}`}>
              {currentContent.values.title}
            </h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {currentContent.values.items.map((item, index) => (
                <div key={index} className="bg-white p-6 rounded-lg border border-gray-200 hover:border-[#f2c742] hover:shadow-md transition-all">
                  <div className="w-12 h-12 bg-[#f2c742] bg-opacity-20 rounded-lg flex items-center justify-center mb-4">
                    <svg className="w-6 h-6 text-[#f2c742]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                    </svg>
                  </div>
                  <h4 className={`text-lg font-semibold text-gray-900 mb-2 ${getFontClass()}`}>
                    {item.title}
                  </h4>
                  <p className={`text-gray-600 text-sm ${getFontClass()}`}>
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Section with Contact Info */}
          <div className="mt-16 text-center bg-[#f2c742] rounded-lg p-10">
            <h3 className={`text-2xl md:text-3xl font-bold text-gray-900 mb-4 ${getFontClass()}`}>
              {currentLanguage === 'EN' ? 'Ready to Experience the Difference?' : 'ត្រៀមខ្លួនដើម្បីជួបប្រទះភាពខុសគ្នា?'}
            </h3>
            <p className={`text-lg text-gray-900 mb-6 ${getFontClass()}`}>
              {currentLanguage === 'EN' 
                ? 'Book your appointment today and let us take care of you' 
                : 'កក់ណាត់ជាមុនថ្ងៃនេះ ហើយអនុញ្ញាតឱ្យយើងថែទាំអ្នក'}
            </p>
            
            {/* Contact Buttons */}
            <div className="flex flex-wrap items-center justify-center gap-4 mb-6">
              <a 
                href={`tel:${currentContent.contact.phone}`}
                className="bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                {currentContent.contact.phone}
              </a>
              <a 
                href={currentContent.contact.telegramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
                Telegram: {currentContent.contact.telegram}
              </a>
            </div>
            
            <p className={`text-sm text-gray-800 ${getFontClass()}`}>
              {currentLanguage === 'EN' 
                ? '📞 Call us or message us on Telegram to book your appointment' 
                : '📞 ទូរស័ព្ទមកយើង ឬផ្ញើសារតាម Telegram ដើម្បីកក់កាលវិភាគរបស់អ្នក'}
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;